import React from 'react';

const AdminCard = ({ title, value, icon }) => {
  return (
    <div className="bg-white shadow-md rounded-2xl p-6 w-full max-w-sm transition-transform transform hover:scale-105" style={{background: 'var(--cardBackground)', color:"var(--textMain"}}>
      <div className="flex items-center justify-between" style={{background: 'var(--cardBackground)', color:"var(--textMain"}}>
        <div>
          <h3 className="text-gray-600 text-sm">{title}</h3>
          <p className="text-2xl font-bold text-gray-800">{value}</p>
        </div>
        {icon && <div className="text-blue-500 text-3xl">{icon}</div>}
      </div>
    </div>
  );
};

export default AdminCard;
